/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Hint_CloseInputs */

const en_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` to close`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " to close" }])
			})
		}
	)
);

const zh_hans1_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` 关闭`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " 关闭" }])
			})
		}
	)
);

const pt_br2_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para fechar`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " para fechar" }])
			})
		}
	)
);

const es_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para cerrar`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " para cerrar" }])
			})
		}
	)
);

const fr_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` pour fermer`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " pour fermer" }])
			})
		}
	)
);

const de_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` zum Schließen`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " zum Schließen" }])
			})
		}
	)
);

const ru_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` чтобы закрыть`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " чтобы закрыть" }])
			})
		}
	)
);

const it_search_hint_close = /** @type {((inputs: Search_Hint_CloseInputs) => LocalizedString) & { parts: (inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_CloseInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` per chiudere`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_CloseInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "esc", options: {}, attributes: {} }, { type: "text", value: " per chiudere" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "to close" |
*
* @param {Search_Hint_CloseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_hint_close = /** @type {((inputs?: Search_Hint_CloseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Search_Hint_CloseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Search_Hint_CloseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { esc: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Search_Hint_CloseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_search_hint_close(inputs)
			if (locale === "pt-BR") return pt_br2_search_hint_close(inputs)
			if (locale === "es") return es_search_hint_close(inputs)
			if (locale === "fr") return fr_search_hint_close(inputs)
			if (locale === "de") return de_search_hint_close(inputs)
			if (locale === "ru") return ru_search_hint_close(inputs)
			if (locale === "it") return it_search_hint_close(inputs)
			return en_search_hint_close(inputs)
		}),
		{
			parts: /** @type {(inputs?: Search_Hint_CloseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_search_hint_close.parts === "function" ? zh_hans1_search_hint_close.parts(inputs) : [{ type: "text", value: zh_hans1_search_hint_close(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_search_hint_close.parts === "function" ? pt_br2_search_hint_close.parts(inputs) : [{ type: "text", value: pt_br2_search_hint_close(inputs) }]
				if (locale === "es") return typeof es_search_hint_close.parts === "function" ? es_search_hint_close.parts(inputs) : [{ type: "text", value: es_search_hint_close(inputs) }]
				if (locale === "fr") return typeof fr_search_hint_close.parts === "function" ? fr_search_hint_close.parts(inputs) : [{ type: "text", value: fr_search_hint_close(inputs) }]
				if (locale === "de") return typeof de_search_hint_close.parts === "function" ? de_search_hint_close.parts(inputs) : [{ type: "text", value: de_search_hint_close(inputs) }]
				if (locale === "ru") return typeof ru_search_hint_close.parts === "function" ? ru_search_hint_close.parts(inputs) : [{ type: "text", value: ru_search_hint_close(inputs) }]
				if (locale === "it") return typeof it_search_hint_close.parts === "function" ? it_search_hint_close.parts(inputs) : [{ type: "text", value: it_search_hint_close(inputs) }]
				return typeof en_search_hint_close.parts === "function" ? en_search_hint_close.parts(inputs) : [{ type: "text", value: en_search_hint_close(inputs) }]
			})
		}
	)
);